        <!-- DeptMng 修改机构 -->
<template>
  <div>
    <!-- 表头 -->
    <div class="deptAdd">
      <div class="deptAdd_return" @click="returnClick()">
        <i class="el-icon-arrow-left fl"></i>
        <span class="fl">返回</span>
      </div>
      <h1>修改机构</h1>
      <div class="deptAdd_time clearfix">
        <i class="el-icon-date fl"></i>
        <span class="fl">{{ dataTime }}</span>
        <span class="fl">{{ textTime }}</span>
      </div>
    </div>
    <!-- 修改机构 -->
    <div class="boxs">
      <div class="boxs_content">
        <div class="boxs_input">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText">
          </el-input>
        </div>

        <div class="boxs_tree">
          <el-tree
            class="filter-tree"
            :data="options"
            :props="defaultProps"
            :default-expand-all="false"
            :expand-on-click-node="false"
            :filter-node-method="filterNode"
            ref="tree"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ node.label }} {{ data.value }}</span>
              <span>
                <el-button type="text" size="mini" @click="() => append(data)">
                  修改
                </el-button>
                <el-button
                  v-show="!data.children"
                  type="text"
                  size="mini"
                  @click="() => remove(node, data)"
                >
                  删除
                </el-button>
              </span>
            </span>
          </el-tree>
        </div>
      </div>

      <el-drawer
        :modal="false"
        title="修改机构信息"
        :visible.sync="drawer"
        :modal-append-to-body="false"
        :before-close="handleClose"
        size="60%"
      >
        <div class="clearfix">
          <div class="drawer_box fl">
            <div class="drawer_content clearfix">
              <span class="fl">上级机构：</span>
              <el-cascader
                disabled
                class="fl"
                :show-all-levels="false"
                v-model="value"
                :checkStrictly="true"
                :options="institutions"
                placeholder="请选择"
                filterable
                :props="{ expandTrigger: 'hover', checkStrictly: true }"
                @change="handleChange"
              ></el-cascader>
            </div>
            <div class="drawer_content clearfix">
              <span class="fl">机构名称：</span>
              <div class="fl">
                <el-input
                  placeholder="请输入内容"
                  v-model="maps.deptName"
                  clearable
                >
                </el-input>
              </div>
              <p class="fl">*必填</p>
            </div>
            <div class="drawer_content clearfix">
              <span class="fl">联系人：</span>
              <div class="fl">
                <el-input
                  placeholder="请输入内容"
                  v-model="maps.contactor"
                  clearable
                >
                </el-input>
              </div>
              <p class="fl"></p>
            </div>
            <div class="drawer_content clearfix">
              <span class="fl">联系电话：</span>
              <div class="fl">
                <el-input
                  placeholder="请输入内容"
                  v-model="maps.phone"
                  clearable
                >
                </el-input>
              </div>
              <p class="fl"></p>
            </div>
            <div class="drawer_content clearfix">
              <span class="fl">地址：</span>
              <div class="fl">
                <el-input
                  placeholder="请输入内容"
                  v-model="maps.address"
                  clearable
                >
                </el-input>
              </div>
              <p class="fl"></p>
            </div>
            <div class="drawer_content clearfix">
              <span class="fl">小数点精确位数：</span>
              <div class="fl">
                <el-input
                  placeholder="请输入内容"
                  v-model="maps.postalcode"
                  clearable
                >
                </el-input>
              </div>
              <p class="fl"></p>
            </div>
            <div class="drawer_content clearfix">
              <span class="fl">电子邮箱：</span>
              <div class="fl">
                <el-input
                  placeholder="请输入内容"
                  v-model="maps.email"
                  clearable
                >
                </el-input>
              </div>
              <p class="fl"></p>
            </div>
            <div class="drawer_content clearfix">
              <span class="fl">IP地址：</span>
              <div class="fl">
                <el-input
                  placeholder="请输入内容"
                  v-model="maps.ipAddress"
                  clearable
                >
                </el-input>
              </div>
              <p class="fl"></p>
            </div>
            <div class="drawer_content clearfix">
              <span class="fl">备注：</span>
              <div class="fl">
                <el-input
                  placeholder="请输入内容"
                  v-model="maps.remark"
                  clearable
                >
                </el-input>
              </div>
              <p class="fl"></p>
            </div>

            <div class="drawer_content clearfix">
              <el-button
                class="fl"
                type="primary"
                @click="Modify()"
                icon="el-icon-edit"
                >修改机构</el-button
              >
            </div>
          </div>
          <div class="drawer_box fl">
            <h1>LOGO</h1>
            <div class="drawer_box_list1">
              <img
                class="img1"
                :src="
                  deptLogo.length > 0
                    ? deptLogo
                    : require('../../assets/img/logo.png')
                "
                alt=""
              />
              <input
                class="input1"
                accept="image/jpeg,image/png,image/gif"
                @change="getFile"
                type="file"
              />
            </div>
            <h1>中心主图</h1>
            <div class="drawer_box_list2">
              <img
                class="img2"
                :src="
                  deptPhoto.length > 0
                    ? deptPhoto
                    : require('../../assets/img/bgs.png')
                "
                alt=""
              />
              <input
                class="input2"
                accept="image/jpeg,image/png,image/gif"
                @change="deptPhotoClick"
                type="file"
              />
            </div>
            <h3>修改LOGO / 中心主图后需要刷新页面，才会显示修改后LOGO / 中心主图</h3>
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
// 引入日期时间
import { dateTime } from "../../assets/js/data";
export default {
  data() {
    return {
      // 定时器
      timer: "",
      // 日期时间
      dataTime: "",
      // 星期
      textTime: "",

      // 修改显示/隐藏
      drawer: false,
      input: "",

      // 搜索关键词
      filterText: "",
      // 机构树
      options: [
        {
          id: 1,
          label: "一级 1",
          value: "11",
          children: [
            {
              id: 4,
              label: "二级 1-1",
              children: [
                {
                  id: 9,
                  label: "三级 1-1-1",
                },
                {
                  id: 10,
                  label: "三级 1-1-2",
                },
              ],
            },
          ],
        },
        {
          id: 2,
          label: "一级 2",
          children: [
            {
              id: 5,
              label: "二级 2-1",
            },
            {
              id: 6,
              label: "二级 2-2",
            },
          ],
        },
        {
          id: 3,
          label: "一级 3",
          children: [
            {
              id: 7,
              label: "二级 3-1",
            },
            {
              id: 8,
              label: "二级 3-2",
            },
          ],
        },
      ],
      defaultProps: {
        children: "children",
        label: "label",
        value: "value",
      },

      // 当前机构
      value: [],
      // 上级机构树
      institutions: [],

      // 当前机构ID
      deptId: "",

      // LOGO相对路径
      deptPhotoPath: "",
      // logo
      deptLogo: "",
      // 中心主图
      deptPhoto: "",

      // 修改
      maps: {
        address: "",
        contactor: "",
        deptId: "010000000",
        deptName: "测试1",
        dept_id: "010000000",
        dept_name: "测试1",
        email: "",
        ipAddress: "",
        ip_address: "",
        level: "1",
        parentId: "000000000",
        parent_id: "000000000",
        phone: "",
        postalcode: "",
        queryrowid: "1",
        remark: "",
        status: "1",
      },
    };
  },
  created() {
    //   日期时间赋值
    this.dataTime = dateTime();
    //   清除定时器
    window.clearInterval(this.timer);
    let _this = this;
    // 定时更新时间
    this.timer = setInterval(() => {
      _this.dataTime = dateTime();
    }, 1000);
    // 调用机构树
    this.DeptMng();

    let date = new Date();
    let num = date.getDay();
    if (num == 0) {
      this.textTime = "星期天";
    }
    if (num == 1) {
      this.textTime = "星期一";
    }
    if (num == 2) {
      this.textTime = "星期二";
    }
    if (num == 3) {
      this.textTime = "星期三";
    }
    if (num == 4) {
      this.textTime = "星期四";
    }
    if (num == 5) {
      this.textTime = "星期五";
    }
    if (num == 6) {
      this.textTime = "星期六";
    }

    this.options = JSON.parse(localStorage.getItem("structure"));
    // 获取上级机构树
    this.institutionsList(this.options);
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    logoPhoto(num) {
      // 获取loginToken,deptId
      let loginToken = localStorage.getItem("loginToken");
      let deptId = localStorage.getItem("deptId");

      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "DeptMng", //交易码
          option: "VIEW", //交易选项，或填EDIT
          deptId: this.deptId, //机构ID
          loginToken,
        },
      })
        .then((res) => {
          console.log(res, "-------------");
          if (res.data._STATUS == 0) {
            if (num == 1) {
              // logo
              if (res.data.deptLogo !== "") {
                // 获取LOGO相对路径
                this.deptPhotoPath =
                  this.logoUrl + localStorage.getItem("deptPhotoPath");
                this.deptLogo = this.deptPhotoPath + res.data.deptLogo;
                this.$message({
                  type: "success",
                  message: "上传成功！",
                });
              } else {
                this.$message({
                  message: "上传失败或无权限上传!",
                  type: "warning",
                });
                this.deptLogo = "";
              }
            }
            if (num == 2) {
              // 中心主图
              if (res.data.deptPhoto !== "") {
                // 获取中心主图相对路径
                this.deptPhotoPath =
                  this.logoUrl + localStorage.getItem("deptPhotoPath");

                this.deptPhoto = this.deptPhotoPath + res.data.deptPhoto;
                // console.log(this.deptPhoto);

                // console.log(this.deptPhoto);
                this.$message({
                  type: "success",
                  message: "上传成功！",
                });
              } else {
                this.$message({
                  message: "上传失败或无权限上传!",
                  type: "warning",
                });
                this.deptPhoto = "";
              }
            }
          } else {
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 上传中心主图
    deptPhotoClick(e) {
      let deptId = localStorage.getItem("deptId");
      let loginToken = localStorage.getItem("loginToken");
      let file = e.target.files[0];
      console.log(file);

      if (file.size / 1024 > 2048) {
        // this.$message({
        //   message: "图片大小超过2M,上传失败!",
        //   type: "warning",
        // });
        this.$notify({
          message: "图片大小超过2M,上传失败!",
          position: "top-left",
          type: "warning",
        });
        return;
      }
      if (file.size / 1024 <= 0) {
        // this.$message({
        //   message: "图片大小异常，请重新上传!",
        //   type: "warning",
        // });
        this.$notify({
          message: "图片大小异常，请重新上传!",
          position: "top-left",
          type: "warning",
        });
        return;
      }

      //创建form对象
      let param = new FormData();
      //通过append向form对象添加数据
      param.append("txcode", "DeptMng");
      param.append("option", "AddPhoto");
      param.append("deptId", this.deptId);
      param.append("nametype", "SYSTEM");
      param.append("upload", file);
      param.append("loginToken", loginToken);
      //FormData私有类对象，通过get判断值是否传进去
      // console.log(param.get("upload"));

      this.$axios({
        method: "post",
        url: this.api + "?_uploadid=" + file.lastModified,
        data: param,
        config: {
          headers: { "Content-Type": "multipart/form-data" },
        },
      })
        .then((res) => {
          if (res.data._ERROR == "无访问权限") {
            // this.$message({
            //   message: "无上传权限!",
            //   type: "warning",
            // });
            this.$notify({
              message: "无上传权限!",
              position: "top-left",
              type: "warning",
            });
            return;
          }
          console.log(res);
          if (res.data._STATUS == "0") {
            // this.logoPhoto("2")
            // 获取中心主图相对路径
            this.deptPhotoPath =
              this.logoUrl + localStorage.getItem("deptPhotoPath");
            this.deptPhoto = this.deptPhotoPath + res.data.imgName;
            // this.$message({
            //   type: "success",
            //   message: "上传成功！",
            // });
            this.$notify({
              message: "上传成功！",
              position: "top-left",
              type: "success",
            });
          } else {
            // 登录超时调用
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 上传LOGO
    getFile(e) {
      let deptId = localStorage.getItem("deptId");
      let loginToken = localStorage.getItem("loginToken");
      let file = e.target.files[0];

      if (file.size / 1024 > 2048) {
        // this.$message({
        //   message: "图片大小超过2M,上传失败!",
        //   type: "warning",
        // });
        this.$notify({
          message: "图片大小超过2M,上传失败!",
          position: "top-left",
          type: "warning",
        });
        return;
      }
      if (file.size / 1024 <= 0) {
        // this.$message({
        //   message: "图片大小异常，请重新上传!",
        //   type: "warning",
        // });
        this.$notify({
          message: "图片大小异常，请重新上传!",
          position: "top-left",
          type: "warning",
        });
        return;
      }

      //创建form对象
      let param = new FormData();
      //通过append向form对象添加数据
      param.append("txcode", "DeptMng");
      param.append("option", "AddLogo");
      param.append("deptId", this.deptId);
      param.append("nametype", "SYSTEM");
      param.append("upload", file);
      param.append("loginToken", loginToken);
      //FormData私有类对象，通过get判断值是否传进去
      // console.log(param.get("upload"));

      this.$axios({
        method: "post",
        url: this.api + "?_uploadid=" + file.lastModified,
        data: param,
        config: {
          headers: { "Content-Type": "multipart/form-data" },
        },
      })
        .then((res) => {
          if (res.data._ERROR == "无访问权限") {
            // this.$message({
            //   message: "无上传权限!",
            //   type: "warning",
            // });
            this.$notify({
              message: "无上传权限!",
              position: "top-left",
              type: "warning",
            });
            return;
          }
          console.log(res, this.deptId);
          if (res.data._STATUS == 0) {
            // this.logoPhoto("1")
            // 获取LOGO相对路径
            this.deptPhotoPath =
              this.logoUrl + localStorage.getItem("deptPhotoPath");
            this.deptLogo = this.deptPhotoPath + res.data.imgName;
            // this.$message({
            //   type: "success",
            //   message: "上传成功！",
            // });

            this.$notify({
              message: "上传成功！",
              position: "top-left",
              type: "success",
            });
          } else {
            // 登录超时调用
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 返回上一级
    returnClick() {
      this.$router.go(-1);
    },

    // 获取上级机构
    institutionsList(options) {
      let data = options;
      let _this = this;
      for (let i = 0; i < data.length; i++) {
        (function (i) {
          if (data[i].children) {
            for (let j = 0; j < data[i].children.length; j++) {
              (function (i, j) {
                if (data[i].children[j].children) {
                  for (
                    let k = 0;
                    k < data[i].children[j].children.length;
                    k++
                  ) {
                    (function (i, j, k) {
                      if (data[i].children[j].children[k].children) {
                        data[i].children[j].children[k].children = undefined;
                      }
                    })(i, j, k);
                  }
                }
              })(i, j);
            }
          }
        })(i);
      }
      let arr = [
        {
          children: [],
          label: "顶级",
          level: 0,
          parentId: "000000000",
          value: "000000000",
        },
      ];
      arr[0].children = data;
      // 设置上级机构树
      this.institutions = arr;
      // console.log(this.institutions);
    },

    // 提交修改
    Modify() {
      if (this.maps.deptName !== "") {
        console.log(this.maps);

        let loginToken = localStorage.getItem("loginToken");
        this.$axios({
          method: "post",
          url: this.api,
          data: {
            txcode: "DeptMng", //交易码
            option: "MODI", //交易选项
            deptId: this.maps.deptId, //机构ID（该值标识为哪个机构，其本身不能被修改）
            deptName: this.maps.deptName, //机构名称
            status: 1, //启用状态，0停用，1启用。（固定填1，该项作为预留参数）
            contactor: this.maps.contactor, //联系人
            phone: this.maps.phone, //联系电话
            address: this.maps.address, //地址
            postalcode: this.maps.postalcode, //小数点精确位数
            email: this.maps.email, //电子邮箱
            ipAddress: this.maps.ipAddress, //IP地址
            remark: this.maps.remark, //备注
            loginToken,
          },
        })
          .then((res) => {
            if (res.data._STATUS == 0) {
              this.DeptMng();
              this.drawer = false;
              // this.$message({
              //   message: "添加成功",
              //   type: "success",
              // });
              this.$notify({
                message: "修改成功！",
                position: "top-left",
                type: "success",
              });
            } else {
              // 登录超时，调用全局方法
              this.loginTimeout();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        // this.$message({
        //   message: "必填内容不能为空！",
        //   type: "warning",
        // });

        this.$notify({
          message: "必填内容不能为空！",
          position: "top-left",
          type: "warning",
        });
      }
    },

    // 获取机构列表
    DeptMng() {
      let loginToken = localStorage.getItem("loginToken");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "DeptMng", //交易码
          option: "LIST", //交易选项
          subDept: "", //要查询的节点机构ID，返回其本身及所有下属机构，留空则默认所有机构。
          deptName: "", //机构名称，作为模糊查询条件，返回与该名称相匹配的记录。
          showType: 1, //显示方式，固定为1。
          loginToken,
        },
      })
        .then((res) => {
          if (res.data._STATUS == 0) {
            if (res.data.list.length > 0) {
              let list = res.data.list;

              // 机构分层
              let layer1 = [];
              let layer2 = [];
              let layer3 = [];
              let layer4 = [];

              for (let i = 0; i < list.length; i++) {
                if (list[i].level == 1) {
                  let arr = {
                    value: list[i].deptId,
                    label: list[i].deptName,
                    parentId: list[i].parentId,
                    level: list[i].level,
                    children: [],
                  };
                  layer1.push(arr);
                }
                if (list[i].level == 2) {
                  let arr = {
                    value: list[i].deptId,
                    label: list[i].deptName,
                    parentId: list[i].parentId,
                    level: list[i].level,
                    children: [],
                  };
                  layer2.push(arr);
                }
                if (list[i].level == 3) {
                  let arr = {
                    value: list[i].deptId,
                    label: list[i].deptName,
                    parentId: list[i].parentId,
                    level: list[i].level,
                    children: [],
                  };
                  layer3.push(arr);
                }
                if (list[i].level == 4) {
                  let arr = {
                    value: list[i].deptId,
                    label: list[i].deptName,
                    parentId: list[i].parentId,
                    level: list[i].level,
                  };
                  layer4.push(arr);
                }
              }

              // 合并分层 3-4
              for (let i = 0; i < layer4.length; i++) {
                for (let j = 0; j < layer3.length; j++) {
                  (function (i, j) {
                    if (layer4[i].parentId == layer3[j].value) {
                      layer3[j].children.push(layer4[i]);
                    }
                  })(i, j);
                }
              }

              for (let i = 0; i < layer3.length; i++) {
                if (layer3[i].children.length == 0) {
                  delete layer3[i].children;
                }
              }

              // 合并分层 2-3
              for (let i = 0; i < layer3.length; i++) {
                for (let j = 0; j < layer2.length; j++) {
                  (function (i, j) {
                    if (layer3[i].parentId == layer2[j].value) {
                      layer2[j].children.push(layer3[i]);
                    }
                  })(i, j);
                }
              }

              for (let i = 0; i < layer2.length; i++) {
                if (layer2[i].children.length == 0) {
                  delete layer2[i].children;
                }
              }

              // 合并分层 1-2
              for (let i = 0; i < layer2.length; i++) {
                for (let j = 0; j < layer1.length; j++) {
                  (function (i, j) {
                    if (layer2[i].parentId == layer1[j].value) {
                      layer1[j].children.push(layer2[i]);
                    }
                  })(i, j);
                }
              }

              for (let i = 0; i < layer1.length; i++) {
                if (layer1[i].children.length == 0) {
                  delete layer1[i].children;
                }
              }

              // 存储机构树
              let structure = JSON.stringify(layer1);

              this.options = JSON.parse(structure);
              localStorage.setItem("structure", structure);
            } else {
              localStorage.setItem("structure", "");
            }
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 修改显示/隐藏
    handleClose() {
      this.drawer = false;
    },
    // 修改
    append(data) {
      this.drawer = true;

      // 上级机构ID
      this.value = data.parentId;

      // 当前机构ID
      this.deptId = data.value;

      let loginToken = localStorage.getItem("loginToken");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "DeptMng", //交易码
          option: "VIEW", //交易选项
          deptId: this.deptId, //机构ID
          loginToken,
        },
      })
        .then((res) => {
          // console.log(res, "res");
          if (res.data._STATUS == 0) {
            this.maps = res.data.map;

            // LOGO相对路径
            this.deptPhotoPath = this.logoUrl + res.data.deptPhotoPath;

            let deptLogo = res.data.deptLogo;
            let deptPhoto = res.data.deptPhoto;

            if (deptLogo !== "" && deptLogo !== null) {
              this.deptLogo = this.deptPhotoPath + deptLogo;
            } else {
              this.deptLogo = "";
            }

            if (deptPhoto !== "" && deptPhoto !== null) {
              this.deptPhoto = this.deptPhotoPath + deptPhoto;
            } else {
              this.deptPhoto = "";
            }
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 删除
    remove(node, data) {
      this.$confirm(
        "此操作将永久删除【" +
          data.label +
          "-" +
          data.value +
          "】该数据, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          let loginToken = localStorage.getItem("loginToken");
          this.$axios({
            method: "post",
            url: this.api,
            data: {
              txcode: "DeptMng", //交易码
              option: "DEL", //交易选项
              deptId: data.value, //机构ID
              loginToken,
            },
          })
            .then((res) => {
              if (res.data._STATUS == 0) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.DeptMng();
              } else {
                // 登录超时，调用全局方法
                this.loginTimeout();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 现在所属机构
    handleChange(value) {
      console.log(value, "所属机构");
      // this.list.parentId = value[value.length - 1];
      // this.list.level = value.length;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
  },
};
</script>

<style lang="less" scoped>
// 表头
.deptAdd {
  width: 100%;
  height: 50px;
  background-color: #304156;
  position: relative;
  h1 {
    min-width: 300px;
    margin: 0 auto;
    height: 50px;
    line-height: 50px;
    font-size: 26px;
    letter-spacing: 6px;
    font-weight: bold;
    text-align: center;
    color: #fff;
  }
  .deptAdd_return {
    position: absolute;
    top: 0;
    left: 0;
    height: 50px;
    overflow: hidden;
    line-height: 50px;
    color: #fff;
    &:hover {
      cursor: pointer;
      text-shadow: #000 0 0 2px;
    }
    i {
      font-weight: bold;
      margin-left: 20px;
      font-size: 20px;
      line-height: 52px;
    }
    span {
      line-height: 50px;
      font-size: 20px;
    }
  }
  .deptAdd_time {
    position: absolute;
    top: 0;
    right: 0;
    height: 50px;
    padding: 0 20px;
    color: #fff;
    i {
      font-size: 32px;
      line-height: 50px;
    }
    span {
      margin: 0 20px;
      font-size: 28px;
      line-height: 50px;
    }
  }
}

.boxs {
  position: absolute;
  top: 60px;
  left: 20px;
  overflow-y: auto;
  width: calc(100% - 10px);
  height: calc(100% - 70px);
  background-color: #ffffff;
}
.boxs_content {
  width: 50%;
  min-width: 800px;
  height: 100%;
  padding: 10px 15px;
  box-sizing: border-box;
  margin: 0 auto;
  .boxs_input {
    margin: 10px 0;
  }
  .boxs_tree {
    width: 100%;
    height: calc(100% - 100px);
    box-sizing: border-box;
    overflow: hidden;
    overflow-y: auto;
  }
}
.drawer_box {
  width: 50%;
  padding: 0 40px;
  box-sizing: border-box;
  .drawer_content {
    // display: flex;
    // justify-content: center;
    width: 100%;
    line-height: 40px;
    margin: 10px 0;
    margin-left: 10%;
    span {
      width: 140px;
      margin-right: 10px;
      text-align: right;
    }
    .el-button {
      margin-top: 20px;
      width: 260px;
      margin-left: 80px;
    }
    p {
      width: 50px;
      margin: 0 10px;
      color: red;
    }
  }

  h1 {
    line-height: 40px;
    color: #333;
    font-size: 18px;
    margin-top: 15px;
  }
  .drawer_box_list1 {
    height: 100px;
    width: 100px;
    position: relative;
    .input1 {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 99;
      opacity: 0;
    }
    .img1 {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  .drawer_box_list2 {
    width: 100%;
    height: 250px;
    position: relative;
    .input2 {
      width: 100%;
      height: 250px;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 99;
      opacity: 0;
    }
    .img2 {
      width: 100%;
      height: 250px;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  h3{
    margin: 5px 0;
    font-size: 16px;
    color: red;
  }
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  padding-right: 18px;
  .el-button {
    font-size: 14px;
  }
}
</style>